import { PRICE_STATE_FROM, PRICE_STATE_NOW_FROM, PRICE_STATE_WAS, PRICE_STATE_RRP, PRICE_STATE_LOWEST, PRICE_STATE_ORIGINAL, } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import AsNumeral from '../vendors/asNumeral';
import { getOriginalPrices, showLowestPriceLastMonth } from '@as-react/common-utils';
const pricingStateTranslationConfig = {
    [PRICE_STATE_FROM]: 'product:product.price.from',
    [PRICE_STATE_NOW_FROM]: 'product:product.price.nowFrom',
    [PRICE_STATE_RRP]: 'product:product.price.rrp',
    [PRICE_STATE_WAS]: 'product:product.price.was',
    [PRICE_STATE_LOWEST]: 'product:product.price.lowest',
    [PRICE_STATE_ORIGINAL]: 'product:product.price.original',
};
export const usePriceViewModel = (priceInformation, fallback, enablePriceReference) => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const formatAsCurrency = AsNumeral.formatAsCurrency;
    const generatePriceLabel = (priceLabel) => !!priceLabel && pricingStateTranslationConfig[priceLabel]
        ? t(pricingStateTranslationConfig[priceLabel])
        : ' ';
    if (!(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) || !(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices.SELL)) {
        return fallback
            ? Object.assign(Object.assign({}, fallback), { enablePriceReference }) : {
            priceActual: {
                formattedPrice: '',
                priceLabel: '',
            },
            enablePriceReference,
        };
    }
    const priceActual = {
        formattedPrice: formatAsCurrency(priceInformation.prices.SELL.original),
        priceLabel: generatePriceLabel(priceInformation.prices.SELL.priceState),
    };
    let pricePrevious;
    let priceReference;
    if (priceInformation.hasDiscount && priceInformation.prices.STD) {
        pricePrevious = {
            formattedPrice: formatAsCurrency(priceInformation.prices.STD.original),
            priceLabel: generatePriceLabel(priceInformation.prices.STD.priceState),
        };
    }
    else if (priceInformation.prices.RRP) {
        pricePrevious = {
            formattedPrice: formatAsCurrency(priceInformation.prices.RRP.original),
            priceLabel: generatePriceLabel(priceInformation.prices.RRP.priceState),
        };
    }
    if (showLowestPriceLastMonth(Boolean(enablePriceReference), (_a = priceInformation.prices.LOWEST) === null || _a === void 0 ? void 0 : _a.original) &&
        !!pricePrevious) {
        const { STD, RRP, SELL, LOWEST } = getOriginalPrices(priceInformation.prices);
        const originalPrice = STD !== null && STD !== void 0 ? STD : RRP;
        if (!LOWEST || !originalPrice) {
            return {
                priceActual,
                pricePrevious,
                enablePriceReference,
            };
        }
        if (LOWEST > SELL && LOWEST < originalPrice) {
            priceReference = Object.assign(Object.assign({}, pricePrevious), { priceLabel: generatePriceLabel(PRICE_STATE_ORIGINAL) });
            pricePrevious = {
                formattedPrice: formatAsCurrency(LOWEST),
                priceLabel: undefined,
            };
        }
        else if (LOWEST <= SELL) {
            priceReference = {
                formattedPrice: formatAsCurrency(LOWEST),
                priceLabel: generatePriceLabel(PRICE_STATE_LOWEST),
            };
        }
    }
    return {
        priceActual,
        pricePrevious,
        priceReference,
        enablePriceReference,
    };
};
